import { compose, lifecycle, withProps } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { selectors as settingsSelectors } from 'state/settings';
import {
  selectors as paymentDataSelectors,
  actions as paymentDataActions,
} from 'state/paymentData';
import { selectors as errorsSelectors } from 'state/errors';
import { selectors as warningsSelectors } from 'state/warnings';
import {
  actions as orderActions,
  selectors as orderSelectors,
  selectorsByType,
} from 'state/order';

import { methods as errorMethods } from 'utils/errors';
import { isEmpty } from 'utils/types';

import PaymentData from 'components/PaymentData/component';

const enhance = compose(
  withTranslation('PaymentData'),
  connect(
    (state) => {
      const orderType = orderSelectors.getTypeOfOrder(state);

      const quote = selectorsByType.quote[orderType].getQuote(state);

      return {
        country: settingsSelectors.getCountrySettings(state),
        errors: errorsSelectors.getErrors(state),
        warnings: warningsSelectors.getWarnings(state),
        fullPrice: Number(quote.gross_full_price),

        hasQuoteError: selectorsByType.quote[orderType].getQuoteError(state),
        isSubmitting: selectorsByType.ui[orderType].getIsSubmitting(state),
        paymentData: paymentDataSelectors.getPaymentData(state),
      };
    },
    {
      fetchQuote: orderActions.fetchQuote,
      submitPaymentData: paymentDataActions.submitPaymentData,
    }
  ),
  lifecycle({
    componentDidMount() {
      const { fetchQuote } = this.props;

      fetchQuote();
    },
  }),
  withProps(({ warnings, errors }) => ({
    hasPastError:
      errorMethods.hasPastError(warnings) || errorMethods.hasPastError(errors),
    hasErrors: !isEmpty(errors) || !isEmpty(warnings),
  }))
);

export default enhance(PaymentData);
